import { IUserLoginInfo } from '@/api/user';

const useLoginAuth = (account?: IUserLoginInfo) => {
  return {
    /** 当前用户是否登录 */
    isLogin: !!account && !!account.id,
  }
}

export default useLoginAuth;